import { AxiosRequestConfig } from 'axios'
import { Get } from './Get'
import { CreateLicenseTypeDto, UpdateLicenseTypeDto } from './License.interface'
import { Post } from './Post'
import { Put } from './Put'
import { Delete } from './Delete'
import { ApiHelpers, APIHosts } from './ApiHelpers'

class LicenseServiceController extends ApiHelpers {
  ApiHost = APIHosts.LicenseManager;

  public Get = {
    getLicenseInfoById: (id: string, options: AxiosRequestConfig = {}) => {
      const baseUrl = this.getHost(this.ApiHost);
      return Get(`${baseUrl}/licenseTypes/${id}`, options)
    },
    getLicenseTypes: (options: AxiosRequestConfig = {}) => {
      const baseUrl = this.getHost(this.ApiHost);
      return Get(`${baseUrl}/licenseTypes`, options)
    },
  }

  public Post = {
    createLicenseType: (
      data: CreateLicenseTypeDto,
      options: AxiosRequestConfig = {},
    ) => {
      const baseUrl = this.getHost(this.ApiHost);
      return Post(`${baseUrl}/licenseTypes`, data, options)
    },
  }

  public Put = {
    updateLicenseType: (
      guid: string,
      data: UpdateLicenseTypeDto,
      options: AxiosRequestConfig = {},
    ) => {
      const baseUrl = this.getHost(this.ApiHost);
      return Put(
        `${baseUrl}/licenseTypes/${guid}`,
        data,
        options,
      )
    },
  }

  public Delete = {
    deleteLicenseType: (guid: string, options: AxiosRequestConfig = {}) => {
      const baseUrl = this.getHost(this.ApiHost);
      return Delete(
        `${baseUrl}/licenseTypes/${guid}`,
        {},
        options,
      )
    },
  }
}

export const LicenseService = new LicenseServiceController()
